var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.206 4.07341C10.2796 4.07341 10.3397 4.01363 10.3363 3.94007C10.2773 2.66092 9.36992 1.66675 8.03932 1.66675H4.5793C3.1993 1.66675 2.2793 2.63341 2.2793 4.06675V8.52675C2.2793 9.88888 3.19473 10.8628 4.52598 10.9237C4.59954 10.9271 4.6593 10.8671 4.6593 10.7934V7.47341C4.6593 5.50675 6.04596 4.07341 7.95932 4.07341H10.206Z",
    fill: "#af8b36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4228 5.07544H7.95948C6.58544 5.07544 5.66211 6.03877 5.66211 7.47279V11.9361C5.66211 13.3695 6.58544 14.3335 7.95948 14.3335H11.4221C12.7968 14.3335 13.7201 13.3695 13.7201 11.9361V7.47279C13.7201 6.03877 12.7968 5.07544 11.4228 5.07544Z",
    fill: "#af8b36"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainCopy);
export default __webpack_public_path__ + "static/media/main-copy.a2d7e314551a6fd6e14163bbea071340.svg";
export { ForwardRef as ReactComponent };